import Util from "@/helper/Utility";

export function CartItems() {
    this.itemList = [];
    this.mode = 'add';

    /**
     * @param {string|number} campaignId
     * @param {number} qty
     */
    this.addItem = function(campaignId, qty) {
        this.itemList.push({
            id: campaignId,
            qty: qty
        });
    };

    this.getParams = function () {
        let params = {
            json: JSON.stringify(this.itemList),
            mode: this.mode
        };
        
        return Util.cleanObjectEmptyStr(params);
    }

    // this.getItemListJson = function() {
    //     return JSON.stringify(this.itemList);
    // };
}
